import options from './options.json';
import translations from './translations.json';

type SimpleOptions = typeof options;
export type Options = SimpleOptions & {
  productRanges: {
    category: string;
    title: string;
    description: string;
    imageUrl?: string;
    fromPrice?: string;
    offerText?: string;
    featuresComparison?: { label: string; isIncluded: boolean }[];
  }[];
  ratings: {
    productRatingsId: string;
  };
  displayNewAddToBagButton: boolean;
  displayFavoriteButton: boolean;
};
export const defaultOptions = options;

export type Translations = typeof translations;
export const defaultTranslations = translations;
export const pbSelector = 'cat-product-details-hero';
